import React from "react";
import { useTranslation } from 'react-i18next';
import { Button } from "../../components/ui/button";

interface ModalProps {
  isVisible: boolean;
  onClose: () => void;
}

const ModalComponent: React.FC<ModalProps> = ({ isVisible, onClose }) => {
  const { t } = useTranslation();
  
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
        <div className="flex justify-between items-center">
          <h3 className="text-lg mx-auto">
            {t('paymentModal.successTitle')}
          </h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            &times;
          </button>
        </div>
        <div className="mt-4">
          <p className="text-gray-400 text-sm text-center">
            {t('paymentModal.successMessage')}
          </p>
        </div>
        <div className="flex flex-col justify-center items-center mt-6">
          <Button
            className="bg-green-500 text-white p-2 rounded hover:bg-green-600 w-[200px]"
            style={{ borderRadius: "50px", height: "2em" }}
            onClick={onClose}
          >
            {t('paymentModal.checkPriceButton')}
          </Button>

          <Button
            className="bg-yellow-500 text-black mt-3 p-2 rounded hover:bg-green-600 w-[200px]"
            style={{ borderRadius: "50px", height: "2em" }}
            onClick={onClose}
          >
            {t('paymentModal.viewDetailsButton')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ModalComponent;